import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Zap, Database } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-amber-950/20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-153">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-600/10 blur-[100px] rounded-full pointer-events-none" data-id="element-154" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-155">
        <FadeIn className="text-center mb-16" data-id="element-156">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/20 text-amber-300 text-sm font-medium mb-6 border border-amber-500/30" data-id="element-157">
            <Zap className="w-4 h-4" data-id="element-158" />
            <span data-id="element-159">El Mecanismo Único</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-160">
            Presentamos el Protocolo P.A.U.
          </h2>
          <p className="text-xl md:text-2xl text-amber-200 font-medium mb-6" data-id="element-161">
            Proyectar • Analizar • Ubicar
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-162">
          <div className="bg-stone-900/80 backdrop-blur-sm border border-amber-500/20 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-163">
            <div className="prose prose-lg prose-invert max-w-none" data-id="element-164">
              <p className="text-stone-300 leading-relaxed text-lg md:text-xl" data-id="element-165">
                A diferencia del diario tradicional, este es un método de{' '}
                <strong className="text-white" data-id="element-166">"extracción clínica"</strong>. No
                escribimos poesía; extraemos datos corruptos de tu sistema
                nervioso para forzar el apagado cognitivo.
              </p>

              <div className="my-8 flex items-center justify-center gap-4 text-amber-400" data-id="element-167">
                <Database className="w-8 h-8" data-id="element-168" />
                <div className="h-px w-16 bg-amber-500/30" data-id="element-169" />
                <ShieldCheck className="w-8 h-8" data-id="element-170" />
              </div>

              <p className="text-stone-300 leading-relaxed text-lg md:text-xl" data-id="element-171">
                Al asignar cada pensamiento a un espacio físico y temporal fuera
                de tu cabeza, rompes el ciclo de rumiación en{' '}
                <strong className="text-amber-400 font-bold" data-id="element-172">
                  menos de 300 segundos
                </strong>
                .
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}